import { useEffect } from "react";
import { useCompanyStore } from "@/store";
import { type LocalePreference, type ResolvedLocale } from "@njbsoft/store";
import { i18n } from "@njbsoft/i18n";

function getSystemLocale(): ResolvedLocale {
  if (typeof window === "undefined") return "en";
  return navigator.language.startsWith("es") ? "es" : "en";
}

function resolveLocale(pref: LocalePreference): ResolvedLocale {
  if (pref === "en" || pref === "es") return pref;
  return getSystemLocale();
}

export function useLocaleSync() {
  const localePreference = useCompanyStore((s) => s.localePreference);
  const setResolvedLocale = useCompanyStore((s) => s.setResolvedLocale);

  useEffect(() => {
    const resolved = resolveLocale(localePreference);
    setResolvedLocale(resolved);
    void i18n.changeLanguage(resolved);
  }, [localePreference, setResolvedLocale]);
}
